module.exports = __webpack_public_path__ + "static/media/fontanero.f11785f6.png";